import * as Yup from "yup";
import { transformSnakeToCamel } from "utils/transform";

import { ERROR_MESSAGES } from "constants/validation";

/**
 * Product Commission Schema
 * Represents commission details for a specific product
 * Base schema is loose to allow loading legacy data.
 */
export const ComSchema = Yup.object()
  .transform(transformSnakeToCamel)
  .shape({
    id: Yup.string().nullable(),
    name: Yup.string().nullable(),
    commission: Yup.number().nullable(),
    commissionType: Yup.string().nullable(),
    commissionRate: Yup.number().nullable(),
    commissionAmount: Yup.number().nullable(),
    createdAt: Yup.date().nullable(),
    updatedAt: Yup.date().nullable(),
  });

/**
 * Product Commission Validation Schema
 * Strict rules applied only during form submission.
 */
export const ComValidationSchema = ComSchema.clone().shape({
  name: Yup.string().required(ERROR_MESSAGES.REQUIRED),
  commissionRate: Yup.number()
    .min(0, ERROR_MESSAGES.COMMISSION_RATE_RANGE)
    .max(100, ERROR_MESSAGES.COMMISSION_RATE_RANGE)
    .required(ERROR_MESSAGES.REQUIRED),
  commissionAmount: Yup.number()
    .min(0, ERROR_MESSAGES.AMOUNT_MIN(0))
    .required(ERROR_MESSAGES.REQUIRED),
});

/**
 * Reusable schema for the update commissions form
 * Used in Commissions/CommissionsForm.js
 */
export const CommissionsFormSchema = Yup.object().shape({
  commissionsRate: Yup.number()
    .required(ERROR_MESSAGES.REQUIRED)
    .min(0.01, ERROR_MESSAGES.MIN_VALUE(0.01))
    .max(100, ERROR_MESSAGES.MAX_VALUE(100))
    .typeError(ERROR_MESSAGES.INVALID_NUMBER),
});
